import React from 'react'
import Head from 'next/head'
import Layout from '../../components/Layout'
import { BlogTitleSection } from '../../components/BlogPage/BlogTitleSection'
import { HTMLContent } from '../../components/Content'
import { BlogSidebar } from '../../components/BlogPage/BlogSidebar'
import { Container } from '../../components/Container'
import { getPost, getPosts } from '../../asyncLoaders/buttercms'
import { reject, propEq, defaultTo } from 'ramda'

const BlogPostTemplate = ({ post, morePosts, preview }) => {
  return (
    <Layout title={`Blog`} preview={preview !== 0}>
      <Head>
        <title>{`${post.title}`}</title>
        <meta name="description" content={`${post.meta_description}`} />
        <meta property="og:title" content={`${post.title}`} />
        <meta property="og:url" content={`https://nubrakes.com/blog/${post.slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:description" content={`${post.meta_description}`} />
        <meta property="og:image" content={`${post.featured_image}`} />
        <meta property="twitter:card" content={`${post.summary}`} />
        <meta property="twitter:title" content={`${post.title}`} />
        <meta property="twitter:description" content={`${post.meta_description}`} />
        <meta property="twitter:url" content={`https://nubrakes.com/blog/${post.slug}`} />
        <meta property="twitter:image" content={`${post.featured_image}`} />
      </Head>
      <main>
        <BlogTitleSection imagePath={post.featured_image} title={post.title} />
        <section>
          <style jsx>
            {`
              h2 {
                font-weight: 800;
                padding-bottom: 10px;
              }

              p {
                color: #676767;
              }

              img {
                max-width: 100%;
              }
            `}
          </style>
          <Container>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="md:col-span-2">
                <article>
                  <HTMLContent content={post.body} className={'blog-post'} />
                </article>
              </div>
              <div>
                <BlogSidebar posts={morePosts} />
              </div>
            </div>
          </Container>
        </section>
      </main>
    </Layout>
  )
}

export default BlogPostTemplate

export async function getStaticProps({ params, preview = 0 }) {
  const post: any = await getPost(params.slug, preview)

  const postList = await getPosts()

  if (!post) {
    return {
      notFound: true, //https://github.com/vercel/next.js/discussions/10960
    }
  }

  return {
    props: {
      preview,
      post,
      morePosts: reject(propEq('slug', params.slug), defaultTo([], postList as readonly any[])),
    },
  }
}

export async function getStaticPaths() {
  const allPosts: any = await getPosts()
  return {
    paths: allPosts?.map((post) => `/blog/${post.slug}`) || [],
    fallback: process.env.NODE_ENV !== 'production' && 'blocking',
  }
}
